exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".InstanceDetailsHeader .spinner-container {\n  height: 8px;\n  width: 100%;\n}\n.InstanceDetailsHeader .header-text .clipboard-btn .glyphicon {\n  color: inherit;\n  font-size: 150%;\n}\n", ""]);

